import { ComponentRef, Directive, OnChanges, TemplateRef, ViewContainerRef, input } from '@angular/core';
import { LoadingComponent } from './loading.component';
import { __ } from '@app/shared/functions/object.functions';

@Directive({
    selector: 'ng-template[loading]',
})
export class LoadingDirective implements OnChanges {

    private wrapperContainer!: ComponentRef<LoadingComponent>;

    readonly loading = input(false);
    readonly loadingOptions = input<{width?: string; height?: string; marginTop?: string; marginBottom?: string}>();
    readonly loadingClass = input('');

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef
    ) { }

    ngOnChanges(): void {
        this.renderLoading();
    }

    private renderLoading() {
        if (__.IsNullOrUndefined(this.loading()) && __.IsNullOrUndefined(this.loadingClass())) {
            return;
        }

        if (__.IsNullOrUndefined(this.wrapperContainer)) {
            this.wrapperContainer = this.viewContainerRef.createComponent(LoadingComponent);
        }

        this.wrapperContainer.setInput('templateRef', this.templateRef);
        this.wrapperContainer.setInput('isLoading', this.loading());
        this.wrapperContainer.setInput('options', this.loadingOptions());
        this.wrapperContainer.setInput('cssClass', this.loadingClass());
    }
}
